import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './TelaNovoEndereco.scss';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from './FormSchema';
import Input from '../../../../components/form/Input';
import InputCadastro from '../../../../components/form/InputCadastro';
import InputCelular from '../../../../components/form/InputCelular';
import useFetch from '../../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';
import { ENDERECOS_ALTERAR } from '../../../../services/endereco';

const TelaAlterarEndereco = () => {
  const { t } = useTranslation();
  const { formSchemaAlteraEndereco } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaAlteraEndereco) });
  const { request } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const endereco = dados[0];
  const idCorreios = dados[1];
  const ipAddress = dados[2];
  const [desabilitarSemNumero, setDesabilitarSemNumero] = useState(false);
  const [desabilitarNumero, setDesabilitarNumero] = useState(false);
  const [semNumero, setSemNumero] = useState(false);
  const navigate = useNavigate();
  const [isCheckedSemNumero, setIsCheckedSemNumero] = useState(false);
  useEffect(() => {
    if (endereco.numero === 'S/N') {
      setSemNumero(true);
      setDesabilitarNumero(true);
      setDesabilitarSemNumero(false);
      setIsCheckedSemNumero(true);
    } else {
      setDesabilitarNumero(false);
      setDesabilitarSemNumero(true);
      setIsCheckedSemNumero(false);
    }
  }, [endereco]);
  const handleNumero = (event) => {
    if (event.target.value.trim() === '') {
      setDesabilitarSemNumero(false);
    } else {
      setDesabilitarSemNumero(true);
    }
  };
  const handleSemNumero = () => {
    setIsCheckedSemNumero(!isCheckedSemNumero);
  };
  useEffect(() => {
    if (isCheckedSemNumero) {
      setDesabilitarNumero(true);
      document.getElementById('numero').value = '';
    } else {
      setDesabilitarNumero(false);
    }
  }, [isCheckedSemNumero]);
  const chamaEndereco = () => {
    navigate('/endereco');
  };

  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const handleSubmit = async (data) => {
    data.preventDefault;
    const enderecoSemId = { ...endereco };
    delete enderecoSemId['idEndereco'];
    delete enderecoSemId['nomePais'];
    if (isCheckedSemNumero) {
      data.numero = 'S/N';
    }
    const dadosEnviar = {
      ...enderecoSemId,
      identificacao: data.identificacao,
      numero: data.numero,
      complemento: data.complemento,
      ddiFixo: data.ddiFixo,
      dddFixo: data.dddFixo,
      foneFixo: data.foneFixo,
    };

    const { response } = await request(
      ENDERECOS_ALTERAR(
        idCorreios,
        endereco.idEndereco,
        dadosEnviar,
        ipAddress,
      ),
    );

    if (response.ok) {
      abreAlertaDialog(t('principal.addresses.messages.updated_success'));
      chamaEndereco();
    }
  };

  return (
    <div className="conteudo cadastro-endereco">
      <div id="cadastro-endereco" className="card bg-superficie elev5">
        <h1>{t('principal.addresses.edit_address')}</h1>

        <form
          id="formAlterarEndereco"
          onSubmit={methods.handleSubmit(handleSubmit)}
        >
          <Input
            type="text"
            id="siglaPais"
            name="siglaPais"
            placeholder=""
            label={t('principal.addresses.country')}
            disabled
            defaultValue={endereco.nomePais}
            {...formMethods}
          />
          <InputCadastro
            type="text"
            id="codigoPostal"
            name="codigoPostal"
            placeholder=""
            label={t('principal.addresses.cep')+'/'+t('principal.addresses.postal_code')}
            disabled
            defaultValue={endereco.codigoPostal}
            {...formMethods}
          />
          <InputCadastro
            type="text"
            id="logradouro"
            name="logradouro"
            placeholder=""
            label={t('principal.addresses.street')}
            disabled
            defaultValue={endereco.logradouro}
            {...formMethods}
          />
          <div className="container-num-comp">
            <InputCadastro
              type="text"
              id="numero"
              name="numero"
              className="campo-numero"
              campoClassName="campo-numero"
              placeholder=""
              label={t('principal.addresses.number')}
              maxLength="10"
              disabled={desabilitarNumero}
              onBlur={handleNumero}
              defaultValue={endereco.numero}
              {...formMethods}
            />
            <label className="input-checkbox">
              <Input
                type="checkbox"
                id="sn"
                name="sn"
                disabled={desabilitarSemNumero}
                onClick={handleSemNumero}
                checked={isCheckedSemNumero}
                {...formMethods}
              />
              <div className="subtitulo-p">{t('principal.addresses.no_number_check')}</div>
            </label>
          </div>

          <InputCadastro
            type="text"
            id="complemento"
            name="complemento"
            className="campo-comp"
            maxLength="100"
            placeholder=""
            label={t('principal.addresses.complement')}
            defaultValue={endereco.complemento}
            {...formMethods}
          />
          <div className="container-cidade-uf">
            <InputCadastro
              type="text"
              id="bairro"
              name="bairro"
              placeholder=""
              label={t('principal.addresses.neighborhood')}
              disabled
              defaultValue={endereco.bairro}
              {...formMethods}
            />
            <InputCadastro
              type="text"
              id="cidade"
              name="cidade"
              placeholder=""
              label={t('principal.addresses.city')}
              disabled
              defaultValue={endereco?.cidade}
              {...formMethods}
            />
            <InputCadastro
              type="text"
              id="uf"
              name="uf"
              className="campo-uf"
              placeholder=""
              label={t('principal.addresses.state_province')}
              disabled
              defaultValue={endereco?.uf}
              {...formMethods}
            />
          </div>

          <div className="container-telefone">
            {endereco.nomePais != 'BRASIL' && (
              <InputCadastro
                type="text"
                className="col-1"
                campoClassName="campo-ddd"
                id="ddiFixo"
                name="ddiFixo"
                maxLength="3"
                label={t('cadastro.forms.labels.ddi')}
                defaultValue={endereco.ddiFixo}
                {...formMethods}
              />
            )}
            <InputCadastro
              type="text"
              className="col-1"
              campoClassName="campo-ddd"
              id="dddFixo"
              name="dddFixo"
              maxLength="3"
              label={t('cadastro.forms.labels.ddd')}
              defaultValue={endereco.dddFixo}
              {...formMethods}
            />
            <InputCadastro
              type="text"
              id="foneFixo"
              name="foneFixo"
              label={t('principal.addresses.landline')}
              maxLength="10"
              defaultValue={endereco?.foneFixo?.replace(
                /(\d{5})(\d{4})/,
                '$1-$2',
              )}
              {...formMethods}
            />
          </div>

          <div className="campo-txt campo-id">
            <Input
              type="text"
              id="identificacao"
              name="identificacao"
              placeholder=""
              label={t('principal.addresses.identification')}
              maxLength="20"
              defaultValue={endereco?.identificacao}
              {...formMethods}
            />

            <div className="mensagem legenda">
              {t('principal.addresses.identification_example')}
            </div>
          </div>

          <div className="btns-row">
            <button
              id="btn-adicionar"
              type="submit"
              className="btn-pre primario"
            >
              {t('principal.forms.buttons.change')}
            </button>

            <button
              id="btn-voltar"
              type="button"
              className="btn-txt"
              onClick={() => chamaEndereco()}
            >
              {t('principal.forms.buttons.cancel')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TelaAlterarEndereco;
